import React from 'react'

import PanelAccordion from '~/components/common/PanelAccordion'

import styles from './OrderContainer.module.scss'

export interface OrderContainerProps {
  children: React.ReactNode
  expanded: boolean
  onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void
  title?: string
}

export const OrderContainer = ({
  expanded,
  title,
  onChange,
  children,
}: OrderContainerProps) => {
  const handleContentClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    // Only handle clicks when expanded
    if (!expanded) return

    // Prevent event from bubbling to accordion header
    e.stopPropagation()

    // Check if click is within an excluded zone (action buttons, menus, dialogs)
    const nativeEvent = e.nativeEvent as MouseEvent & {
      composedPath?: () => EventTarget[]
    }
    const composedPath = nativeEvent.composedPath?.()

    const isExcluded = composedPath
      ? composedPath.some(
          (el): el is HTMLElement =>
            el instanceof HTMLElement && el.dataset.clickExclude === 'true',
        )
      : e.target instanceof HTMLElement &&
        e.target.closest('[data-click-exclude="true"]') !== null

    if (!isExcluded) onChange(e, false)
  }

  if (!title) {
    return <div className={styles.noTitle}>{children}</div>
  }

  return (
    <PanelAccordion
      noPadding
      className={styles.container}
      expanded={expanded}
      title={title}
      onChange={onChange}
      onContentClick={handleContentClick}
    >
      {children}
    </PanelAccordion>
  )
}
